import React from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Alert, Button } from 'reactstrap';
import styled from 'styled-components';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import settings from 'settings';

import VERSION from '../version';

const PreReleaseAlert = styled(Alert)`
  position: fixed !important;
  bottom: 10%;
  left: 10%;
  width: 80%;
`;

export default connect(
  createStructuredSelector({
    lastSeenVersion: state => state.settings.lastSeenPreReleaseWarningVersion
  }),
  {
    setPreReleaseWarningVersion: settings.actions.setPreReleaseWarningVersion
  }
)(
  ({ lastSeenVersion, setPreReleaseWarningVersion }) => {
    const [visible, setVisible] = React.useState(lastSeenVersion !== VERSION);

    const hide = () => {
      setVisible(false);
      setPreReleaseWarningVersion();
    };

    return (
      <PreReleaseAlert
        className='text-center'
        color='info'
        isOpen={visible}
        toggle={() => setVisible(!visible)}
      >
        <h4>Pre-release software</h4>
        <div className='d-flex'>
          <FontAwesomeIcon
            icon={faInfoCircle}
            size='3x'
          />
          <div className='ml-4 text-center'>
            <p>
              JustWords is pre-release software. User experience will be
              incomplete, missing planned functionality, and may not be
              representative of the final released version. Though JustWords has
              already been used in a number of production events, you may
              experience instability and crashes as is the nature of early-access
              software products.
            </p>
            <p>
              You have been provided with early access to JustWords. Features may
              be added and removed while the software remains under development.
              We would value feedback about your experience; you can contact us
              at <a href='mailto:info@justwords.live'>info@justwords.live</a>.
            </p>
            <Button
              color='primary'
              onClick={hide}
            >
              I understand
            </Button>
          </div>
        </div>
      </PreReleaseAlert>
    );

  }
);
